import { useState } from "react";
import { motion } from "framer-motion";
import { IndiaMap } from "./sourcing/IndiaMap";
import { SupplierPanel } from "./sourcing/SupplierPanel";

const HEADER_MOTION = { initial: { opacity: 0, y: 30 }, whileInView: { opacity: 1, y: 0 }, viewport: { once: true, margin: "-100px" }, transition: { duration: 0.6 } };

export function GlobalSourcing() {
  const [active, setActive] = useState(null);
  return (
    <section id="marketplace" data-testid="global-sourcing-section" className="py-24 px-6 relative">
      <div className="max-w-7xl mx-auto">
        <motion.div {...HEADER_MOTION} className="text-center mb-14">
          <span className="font-jetbrains text-xs text-ib-lime tracking-widest uppercase">Pan-India Network</span>
          <h2 className="font-outfit font-extrabold text-3xl sm:text-4xl lg:text-5xl tracking-tight mt-3 text-ib-text">
            Supplier Network Across <span className="text-ib-blue">All States</span>
          </h2>
          <p className="font-manrope text-base md:text-lg text-ib-text-secondary mt-4 max-w-2xl mx-auto">
            Access verified suppliers of HR Coil, CR Coil, TMT Bars, GP Sheet and
            specialty steel from every major manufacturing hub across India.
          </p>
        </motion.div>
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-6 lg:gap-8 items-start">
          <IndiaMap active={active} onHover={setActive} />
          <SupplierPanel active={active} onHover={setActive} />
        </div>
      </div>
    </section>
  );
}
